// extracted by mini-css-extract-plugin
export default {"container":"NotFound_container__YhTn+","link":"NotFound_link__VhtBb","icon":"NotFound_icon__3Jvpz","text":"NotFound_text__EcWFE"};